module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-rules-selected@3x.png?0.0.53";